'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reorderPlayable;

var _store = require('../../../store');

var _store2 = _interopRequireDefault(_store);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reorderPlayable(playerId, sourceIndex, destinationIndex) {
  var player = _store2.default.getPlayerInstance(playerId);

  var playables = player.playables;
  var sourceItem = playables[sourceIndex];
  player.playables.remove(sourceIndex);
  player.playables.insert(sourceItem, destinationIndex);

  // Set playing index to destination
  if (player.playingIndex !== destinationIndex) {
    player.playingIndex = destinationIndex;
  }

  return {
    type: _constants.REORDER_PLAYABLE,
    sourceIndex: sourceIndex,
    destinationIndex: destinationIndex,
    playingIndex: destinationIndex,
    playerId: playerId
  };
}
module.exports = exports['default'];